editAnswerController.$inject = ['$scope', '$uibModalInstance', 'siteTypeName', 'answer', 'hasDescription', 'hasPhoneEmailAnswerType', 'hasUrlAnswerType', 'labelMaxLength', 'chosenAnswerTypes',
  '$translate', 'canShowVerbatimCheckbox', 'numberOfButtons', 'minNumberOfButtonsAllowed', 'maxNumberOfButtonsAllowed'];
export function editAnswerController($scope, $uibModalInstance, siteTypeName, answer, hasDescription, hasPhoneEmailAnswerType, hasUrlAnswerType, labelMaxLength, chosenAnswerTypes,
  $translate, canShowVerbatimCheckbox, numberOfButtons, minNumberOfButtonsAllowed, maxNumberOfButtonsAllowed) {

  $scope.editAnswer = editAnswer;
  $scope.cancel = cancel;
  $scope.delete = deleteAnswer;
  $scope.canAddAnswer = canAddAnswer;
  $scope.canDelete = canDelete;
  $scope.shouldShowVerbatimCheckbox = shouldShowVerbatimCheckbox;
  $scope.isAnswerInvalid = isAnswerInvalid;
  const answerButtonTypes = ['simple-text', 'url', 'app-link'];

  init();

  function editAnswer(answer) {
    $uibModalInstance.close({ type: 'edit', data: answer });
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function deleteAnswer(answer) {
    $uibModalInstance.close({ type: 'delete', data: answer });
  }

  function getSpecialAnswerTypes() {
    let specialAnswerTypes = {};
    specialAnswerTypes['simple-text'] = true;
    specialAnswerTypes['user-input'] = true;
    specialAnswerTypes['phone-number'] = $scope.hasPhoneEmailAnswerType;
    specialAnswerTypes['email'] = $scope.hasPhoneEmailAnswerType;
    specialAnswerTypes['url'] = $scope.hasUrlAnswerType;
    specialAnswerTypes['app-link'] = $scope.hasUrlAnswerType;
    return specialAnswerTypes;
  }

  function getSpecialAnswerTypesInDropdown() {
    let specialAnswerTypesInDropdown = {}
    for (var answerType in $scope.specialAnswerTypes) {
      if (answerType == $scope.answer.answerType ||
        $scope.specialAnswerTypes[answerType] && canAddAnswer(answerType)) {
        specialAnswerTypesInDropdown[answerType] = true;
      }
    }
    return specialAnswerTypesInDropdown;
  }

  function canAddAnswer(answerType) {
    // Bypass the verification if the user is editing a button.
    if ($scope.answer.answerType !== 'user-input' && answerType !== 'user-input') {
      return true;
    }
    return answerButtonTypes.includes(answerType) ? canAddButtonAnswer() : !$scope.chosenAnswerTypes[answerType];
  }

  function canAddButtonAnswer() {
    return !$scope.maxNumberOfButtonsAllowed || $scope.numberOfButtons < $scope.maxNumberOfButtonsAllowed;
  }

  function canDelete() {
    const minNotReached = !$scope.minNumberOfButtonsAllowed || $scope.numberOfButtons > $scope.minNumberOfButtonsAllowed;
    return !answerButtonTypes.includes(answer.answerType) || (minNotReached && !(answer.hasParentMessageWithChoice && answer.answerType === 'next-box-by-default'));
  }

  function initializeButtonVariables() {
    $scope.answer.inputListVariable = $scope.answer.inputListVariable ? $scope.answer.inputListVariable : "labels";
    $scope.answer.selectedButtonIndexVariable = $scope.answer.selectedButtonIndexVariable ? $scope.answer.selectedButtonIndexVariable : "selected_button_index";
  }

  function initializeUrlButton() {
    $scope.answer.UrlButtonUrl = $scope.answer.UrlButtonUrl ? $scope.answer.UrlButtonUrl : "https://";
    $scope.answer.UrlButtonUrlAndroid = $scope.answer.UrlButtonUrlAndroid ? $scope.answer.UrlButtonUrlAndroid : "https://";
    $scope.answer.UrlButtonUrlIos = $scope.answer.UrlButtonUrlIos ? $scope.answer.UrlButtonUrlIos : "https://";
    $scope.answer.UrlButtonName = $scope.answer.UrlButtonName ? $scope.answer.UrlButtonName : $translate.instant('parameters/quick_replies/details/edit_answer/url/name');
  }

  function shouldShowVerbatimCheckbox() {
    return canShowVerbatimCheckbox && ['user-input', 'next-box-by-default'].includes(answer.answerType);
  }


  function init() {
    $scope.hasDescription = hasDescription;
    $scope.hasPhoneEmailAnswerType = hasPhoneEmailAnswerType;
    $scope.hasUrlAnswerType = hasUrlAnswerType;
    $scope.labelMaxLength = labelMaxLength;
    $scope.chosenAnswerTypes = chosenAnswerTypes;
    $scope.answer = answer;
    initializeButtonVariables();
    initializeUrlButton();
    const siteType = { 'siteTypeName': siteTypeName.charAt(0).toUpperCase() + siteTypeName.substring(1) };
    $scope.phoneNumberDescription = $translate.instant('parameters/quick_replies/details/edit_answer/phone_number_description', siteType);
    $scope.emailDescription = $translate.instant('parameters/quick_replies/details/edit_answer/email_description', siteType);
    $scope.locationDescription = $translate.instant('parameters/quick_replies/details/edit_answer/location_description', siteType);
    $scope.handoverMessage = $translate.instant('parameters/quick_replies/details/edit_answer/transfer_tooltip');
    $scope.hasVerbatimModeMessage = $translate.instant('parameters/quick_replies/details/edit_answer/verbatim_tooltip');
    $scope.numberOfButtons = numberOfButtons;
    $scope.maxNumberOfButtonsAllowed = maxNumberOfButtonsAllowed;
    $scope.minNumberOfButtonsAllowed = minNumberOfButtonsAllowed;
    $scope.specialAnswerTypes = getSpecialAnswerTypes();
    $scope.specialAnswerTypesInDropdown = getSpecialAnswerTypesInDropdown();
  }

  function isAnswerInvalid() {
    let isLabelInvalid = false;
    if (answer.answerType === 'simple-text') {
      isLabelInvalid = !answer.label || answer.label.trim().length === 0;
    }
    return editAnswerForm.$invalid || answer.answerType === 'default-answer' || isLabelInvalid;
  }

}
